import React from 'react'

const Image = ({ id, className, clickImage }) => {
    const url = `https://drive.google.com/thumbnail?id=${id}&sz=w1000`;
      
    return (
        <>
         <img
            src={url}
            alt="No pic found"
            className={className}
            onClick={() => clickImage?.(url)} />
        
        </>
       

    )
}

export default Image